export default function Method(routine) {
    let staticMethod = false;
    this.isStatic = () => staticMethod;
    this.run = (context, ...args) => routine.call(context, ...args);
    this.override = (newRoutine) => routine = newRoutine;
}
